import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { clickBaseEvent, viewBaseEvent } from '@chegg-me-components/utils';
import { rioClient } from './variants/LanguageSelector';
export function rioLoggingForLanguageSelectorVisible(selectorData) {
  rioClient.sendEvent(_objectSpread(_objectSpread({}, viewBaseEvent), {}, {
    data: {
      component_view: {
        component: {
          name: 'language selector',
          type: 'drop down',
          region_name: 'top nav',
          text: selectorData.map(function (lang) {
            return lang.language;
          }).join('|').toLowerCase()
        }
      }
    }
  }));
}
export function rioLoggingForLanguageSelected(selectorData, selectedIndex) {
  rioClient.sendEvent(_objectSpread(_objectSpread({}, clickBaseEvent), {}, {
    data: {
      interaction: {
        type: 'select',
        element: {
          text: selectorData.map(function (lang) {
            return lang.language;
          }).join('|').toLowerCase(),
          value: selectorData[selectedIndex].language,
          type: 'drop down',
          name: 'language',
          region_name: 'language selector'
        }
      }
    }
  }));
}
export function rioLoggingForOpeningSelector(selectorData) {
  rioClient.sendEvent(_objectSpread(_objectSpread({}, clickBaseEvent), {}, {
    data: {
      interaction: {
        type: 'click',
        element: {
          text: selectorData.map(function (lang) {
            return lang.language;
          }).join('|').toLowerCase(),
          type: 'drop down',
          name: 'language selector',
          region_name: 'top nav'
        }
      }
    }
  }));
}
export function rioLoggingForClosingSelector() {
  rioClient.sendEvent(_objectSpread(_objectSpread({}, clickBaseEvent), {}, {
    data: {
      interaction: {
        type: 'click',
        element: {
          type: 'icon',
          name: 'exit',
          region_name: 'language selector'
        }
      }
    }
  }));
} // update RIO Client state if signed out

export function updateRIOClientState(signedIn) {
  !signedIn ? rioClient.updateState({
    authState: 'logged_out'
  }) : '';
}